import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '../../services/session.service';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';
import { Md5 } from 'ts-md5/dist/md5';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { UtilityService } from 'src/app/services/utility.service';
import * as $ from 'jquery';

@Component({
	selector: 'app-sample-center-logged-samples',
	templateUrl: './sample-center-logged-samples.component.html',
	styleUrls: ['./sample-center-logged-samples.component.css'],
})
export class SampleCenterLoggedSamplesComponent implements OnInit {
	apiUrl: string;
	dtOptions: any = {};
	submitted = false;
	config: any;
	currentPageLength: any = 10;
	searchObject: any = {};
	loggedSamples: any;
	searchForm: FormGroup;
	singleSampleForm: FormGroup;

	applicationId: string;
    collection_center_appId: any;

	constructor(
		private formBuilder: FormBuilder,
		private http: HttpClient,
		private router: Router,
		private route: ActivatedRoute,
		private utility: UtilityService,
		private sess: SessionService,
		private spinnerService: Ng4LoadingSpinnerService
	) {}

	ngOnInit(searchObj = null) {
		this.sess.checkLogin();

		this.applicationId = localStorage.getItem('application_id');
		this.collection_center_appId = environment.APP_ID_COLLECTION_CENTER;
		this.sess.confirmUser(this.applicationId, this.collection_center_appId, 'Sample Collection Center');

		this.initTable();
		if (searchObj == null || searchObj == '') {
			this.loggedSamples = '';
			this.initialiseForm();
			this.initTable();
			console.log('searchObj is null');
		} else {
			this.loggedSamples = '';
			console.log('searchObj is not null');
		}

		/* Pagination Start */
		this.config = {
			currentPage: 1,
			itemsPerPage: 10,
		};

		this.getLoggedSamples(this.config.itemsPerPage, this.config.currentPage);

		this.route.queryParams.subscribe(
			(params) =>
				(this.config.currentPage = params['page'] ? params['page'] : 1)
		);
	}

	public daterange: any = {};

	public options: any = {
		locale: { format: 'YYYY-MM-DD' },
		alwaysShowCalendars: false,
	};

	initTable() {
		this.dtOptions = {
			paging: false,
			pagingType: 'full_numbers',
			responsive: true,
			pageLength: 10,
			lengthChange: false,
			processing: false,
			ordering: false,
			info: false,
			columnDefs: [
				{
					//targets: [ 10 ],
					visible: false,
					searchable: false,
				},
			],
			dom:
				"<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>" +
				"<'row'<'col-sm-12'tr>>" +
				"<'row'<'col-sm-5'i><'col-sm-7'p>>",
			buttons: [
				// { extend: 'csv',   className: 'btn btn-outline-dark', text: '<i class="fas fa-file-csv"> CSV</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}},
				// { extend: 'excel', className: 'btn btn-outline-dark', text: '<i class="fas fa-file-excel"> Excel</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]} },
				// { extend: 'pdf',   className: 'btn btn-outline-dark', text: '<i class="fas fa-file-pdf"> PDF</i>' , orientation: 'landscape', pageSize: 'LEGAL', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}},
				// { extend: 'print', className: 'btn btn-outline-dark', text: '<i class="far fas fa-print"> Print</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] } }
			],
		};
	}

	initialiseForm() {
		this.searchForm = this.formBuilder.group({
			traveller: [''],
			daterangeInput: [''],
			status: [''],
		});
		this.singleSampleForm = this.formBuilder.group({
			appointmentId: [''],
			fullname: [''],
			phone: [''],
			traveller: [''],
			status: [''],
			date: [''],
		});
	}
	initLoggedSampleForm(sample) {
		this.singleSampleForm = this.formBuilder.group({
			appointmentId: [sample.ctms_passenger_id],
			fullname: [`${sample.first_name} ${sample.middle} ${sample.last_name}`],
			phone: [sample.phone],
			traveller: [sample.type == 1 ? 'OUTBOUND' : 'INBOUND'],
			status: [sample.payment_status == 1 ? 'Paid' : 'Unpaid'],
			date: [`${sample.booking_date} ${sample.booking_time}`],
		});
	}

	public selectedDate(value: any, datepicker?: any) {
		// this is the date  selected
		console.log('selectedDate: ', value);

		// any object can be passed to the selected event and it will be passed back here
		// datepicker.start = value.start;
		// datepicker.end = value.end;

		// use passed valuable to update state
		this.daterange.start = value.start.format('YYYY-MM-DD');
		this.daterange.end = value.end.format('YYYY-MM-DD');
		this.daterange.label = value.label;
	}

	getLoggedSamples(perpage, pageno) {
		this.spinnerService.show();

		this.apiUrl =
			`${environment.AUTHAPIURL}sample-collection/list?page=` + pageno;

		this.searchObject['page_no'] = pageno;
		this.searchObject['per_page'] = perpage;
		this.searchObject['application_id'] =
			localStorage.getItem('application_id');

		const reqHeader = new HttpHeaders({
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + localStorage.getItem('access_token'),
		});

		this.http
			.post<any>(this.apiUrl, this.searchObject, { headers: reqHeader })
			.subscribe((data) => {
				this.spinnerService.hide();
				console.log(data);
				if (data.status == true) {
					this.loggedSamples = data.response.data;
					this.config.totalItems = data.response.total;
				} else {
					Swal.fire({
						icon: 'error',
						title: 'Oops...',
						text: data.response != null ? data.response[0].message : data.message,
						showConfirmButton: true,
						timer: 5000,
						timerProgressBar: true,
					});
				}
			});
	}

	pageChange(newPage: number) {
		this.loggedSamples = '';
		this.router.navigate(['/sample-center-logged-samples'], {
			queryParams: { page: newPage },
		});
		this.getLoggedSamples(this.config.itemsPerPage, newPage);
	}

	public setItemsPerPage(event) {
		this.config.itemsPerPage = event;
		this.currentPageLength = this.config.itemsPerPage;
		this.loggedSamples = '';
		this.router.navigate(['/sample-center-logged-samples']);
		this.getLoggedSamples(this.config.itemsPerPage, 1);
	}

	showModal(modal, data) {
		this.utility.showModal(modal);
		this.initLoggedSampleForm(data);
	}

	onSubmitSearch(formAllData: any) {
		this.submitted = true;

		// stop the process here if form is invalid
		if (this.searchForm.invalid) {
			return;
		}

		this.searchObject = {
			travel_type: parseInt(formAllData.traveller),
			payment_status: formAllData.status,
			date_start:
				this.daterange.start !== undefined ? this.daterange.start : null,
			date_end: this.daterange.end !== undefined ? this.daterange.end : null,
		};

		console.log('searchFormData: ', this.searchObject);
		this.loggedSamples = '';
		this.getLoggedSamples(this.config.itemsPerPage, this.config.currentPage);
	}

	clearSearch() {
		this.loggedSamples = '';
		this.searchObject = {};
		this.initialiseForm();
		this.getLoggedSamples(this.config.itemsPerPage, this.config.currentPage);
	}
}
